import { FormState } from "final-form";
import { SouthAfricaCountryCode } from "../../features/Constants";

export const invalidAlternativeNumber = (
  requesterDetailsForm:
    | FormState<Record<string, any>, Partial<Record<string, any>>>
    | null
    | undefined
) => {
  const mobileNumber =
    requesterDetailsForm?.values.mobileNumber !== undefined &&
    requesterDetailsForm?.values.mobileNumber !== "";
  const alternativeNumber =
    requesterDetailsForm?.values.alternativeNumber !== undefined &&
    requesterDetailsForm?.values.alternativeNumber !== "";

  return (
    mobileNumber &&
    alternativeNumber &&
    requesterDetailsForm?.values.alternativeNumber ===
      requesterDetailsForm?.values.mobileNumber
  );
};

export const southAfricanPassportCountry = (
  requesterDetailsForm:
    | FormState<Record<string, any>, Partial<Record<string, any>>>
    | null
    | undefined
) => {
  return (
    requesterDetailsForm?.values?.individual_passportCountry ===
      SouthAfricaCountryCode ||
    requesterDetailsForm?.values?.taxPractInfo_passportCountry ===
      SouthAfricaCountryCode ||
    requesterDetailsForm?.values?.delegate_passportCountry ===
      SouthAfricaCountryCode ||
    requesterDetailsForm?.values?.registeredRepresentInfo_passportCountry ===
      SouthAfricaCountryCode ||
    requesterDetailsForm?.values?.taxpayer_passportCountry ===
      SouthAfricaCountryCode
  );
};
